import { render, staticRenderFns } from "./LiveUpdatesIndicator.vue?vue&type=template&id=322eb8b1&scoped=true&"
import script from "./LiveUpdatesIndicator.vue?vue&type=script&lang=js&"
export * from "./LiveUpdatesIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LiveUpdatesIndicator.vue?vue&type=style&index=0&id=322eb8b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322eb8b1",
  null
  
)

export default component.exports